/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_Work_OrderInputs */



/**
* | output |
* | --- |
* | "Publish work order" |
*
* @param {Publish_Work_OrderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const publish_work_order = /** @type {((inputs?: Publish_Work_OrderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Work_OrderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publier le bon de travail")
	if (locale === "de") return /** @type {LocalizedString} */ ("Arbeitsauftrag veröffentlichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblica ordine di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опубликовать наряд на выполнение работ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicar orden de trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布工作单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作業指示書を公開する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्य आदेश प्रकाशित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicar ordem de serviço")
	return /** @type {LocalizedString} */ ("Publish work order")
});